import { useEffect, useState, useRef } from 'react';
import { Accordion, Card,useAccordionButton } from 'react-bootstrap';
import {  RecoilRoot,
    atom,
    selector,
    useRecoilState,
    useRecoilValue} from 'recoil';
import './Actividad.styles.css'
import Actividad from "./Actividad";
import useExceptionHandler from '../../Hooks/useExceptionHandler';
import {BUSCAR_SOLICITUDES_COMPANIA, SolicitudesAtom} from '../../Utils';
import { buscar } from '../../Utils/Buscar';
export default function ActividadesContainer({
                                                 where,
                                                 showLoading,
                                                 hideLoading,
                                                 label,
                                                 recargar,
                                                 isActive,
                                             }) {
    const [actividadList, setActividadList] = useState([]);
    const consultaActualId = useRef();
    const [solcitudesState, setSolicitudesState] = useRecoilState(SolicitudesAtom)
    const { handleException } = useExceptionHandler();
    
    useEffect(() => {
        showLoading();
            cargarActividadList();
    }, [where.fuente, where.referencia, recargar]);

    const cargarActividadList = () => {
            const consultaId = Math.random();
            consultaActualId.current = consultaId;
            const url = BUSCAR_SOLICITUDES_COMPANIA;
            buscar(url, { where: {...where} }).then((data) => {
                if (consultaId === consultaActualId.current) {
                    setActividadList(data.Resultados);
                    let nuevasSolicitudes = []
                    let solicitudesStateFlat = solcitudesState.flat();
                    data.Resultados.map((nuevaSolicitud) => {
                        let existe = solicitudesStateFlat.some(solicitud => solicitud.Id === nuevaSolicitud.Id)
                        if(!existe){
                            nuevasSolicitudes.push(nuevaSolicitud);
                       }
                        
                    });
                    setSolicitudesState((prev) => [
                        ...prev,
                        nuevasSolicitudes
                    ])
                }
            }).catch((error) => {
                handleException(error);
            }).finally(() => {
                hideLoading();
            });
    };
    function CustomAccordionHeader({ children, eventKey, style }) {
        const decoratedOnClick = useAccordionButton(eventKey);

        return (
            <div
                as={Card.Title}
                onClick={decoratedOnClick}
                style={{...style}}
            >
                {children}
            </div>
        );
    }
    return (
        <div className="row d-flex justify-content-center mt-20 mb-20">
            <div className="col-md-12">
                <div className="main-card mb-3 card">
                    <Accordion defaultActiveKey={isActive ? '0' : '1'}>
                        <div className="card-body">
                            <Accordion.Item eventKey="0">

                                <CustomAccordionHeader
                                    eventKey="0"
                                    style={{ cursor: 'pointer' }}>
                                    <h4 className="mb-3 mt-2">
                                        {label}
                                        <span className="small">{` (${actividadList.length})`}</span>
                                    </h4>
                                </CustomAccordionHeader>
                                <Accordion.Body style={{ maxHeight: '50vh', overflowY: 'scroll' }}>
                                    {actividadList.length ? (
                                        <div className="vertical-timeline vertical-timeline--animate vertical-timeline--one-column">
                                            {actividadList.map((actividad) => (
                                                <Actividad
                                                    key={`${actividad.Id}-${actividad.TipoSolicitud}`}
                                                    actividad={actividad}
                                                />
                                            ))}
                                        </div>
                                    ) : (
                                        <p className="text-muted ml-3">No hay Solicitudes</p>
                                    )}
                                </Accordion.Body>
                            </Accordion.Item>
                        </div>
                    </Accordion>
                </div>
            </div>
        </div>
    );
}
